import { connect } from 'react-redux';
import { IContentLibCategoryListEvents, IContentLibCategoryListFields } from '../components/types';
import { ContentLibCategoryList } from '../components/ContentLibCategoryList';
import { IState } from '../../../../../store/types';
import { ContentLibSelectors } from '../../../../../store/contentLib/selectors';
import { ContentLibCategoryListEvents } from './events';

const mapStateToProps = (
  dispatch: any
) => {
  return (
    state: IState
  ): IContentLibCategoryListFields => {
    return {
      selectedCategoryId: ContentLibSelectors.getSelectedCategoryId(state),
      categories: ContentLibSelectors.getCategories(state)
    }
  };
}

const mapDispatchToProps = (
  dispatch: any
): IContentLibCategoryListEvents => ({
    onCategorySelect: id => dispatch(ContentLibCategoryListEvents.onCategorySelect(id)),
  }
);

export const ContentLibCategoryListHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentLibCategoryList);

ContentLibCategoryListHOC.displayName = 'ContentLibCategoryListHOC';
